import Link from 'components/Link'
import Text from 'components/Text'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { getSupportLink } from 'services/urlService'
import styled from 'styled-components'
import { color, screenWidth } from 'utils'

import LanguageToggler from './LanguageToggler'

const legalLink = '/legal'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0.5rem;

  & > :first-child {
    width: 30%;
  }

  @media only screen and (min-width: ${screenWidth('sm')}) {
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  @media only screen and (max-width: ${screenWidth('sm')}) {
    visibility: hidden;
  }
`
const Container = styled.div<{ justify: 'left' | 'right' }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;

  & > * {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  @media only screen and (min-width: ${screenWidth('sm')}) {
    width: 70%;
    justify-content: ${(props) => (props.justify === 'left' ? 'flex-start' : 'flex-end')};
  }
`

const Disclaimer = styled.div`
  font-size: 14px;
  text-align: center;
  color: ${color('dark900')};
  font-weight: 500;
  background: ${color('grey300')};
  padding: 0.5rem 1rem;
  margin-top: 2rem;

  > a {
    text-decoration: underline;
  }
`

const Footer = ({ intl, showDisclaimer }) => (
  <footer>
    {showDisclaimer && (
      <Disclaimer>
        This Financial Promotion has been approved by Englebert Ltd on 7 March 2024.
      </Disclaimer>
    )}

    <Wrapper>
      <Container justify='left'>
        <Link
          data-e2e='footerHelpEmailLink'
          href={getSupportLink(intl.locale)}
          size='sm'
          target='_blank'
          weight={600}
        >
          {intl.formatMessage(messages.contact_support)}
        </Link>

        <Link data-e2e='footerLegalLink' href={legalLink} size='sm' target='_blank' weight={600}>
          {intl.formatMessage(messages.legal)}
        </Link>

        <LanguageToggler />
      </Container>
      <Container justify='right'>
        <Text color='grey000' size='sm' style={{ whiteSpace: 'nowrap' }}>
          {intl.formatMessage(messages.copyright, {
            year: new Date().getFullYear()
          })}
        </Text>
      </Container>
    </Wrapper>
  </footer>
)

export default injectIntl(Footer)
